import { isInvalidFileSize, isInvalidFileType } from "src/helpers";
import { isInvalidFileName } from "src/validation/stringValidation";
import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { UploadPurchaseOrdersFormDataKey } from "src/types";

class UploadPurchaseOrdersFormValidator extends FormValidator {
  private static validateFileUpload(value: unknown): ValidationError<"fileUpload"> | undefined {
    if (!value) {
      return new ValidationError("Upload a file", "fileUpload");
    }

    if (isInvalidFileType(value, ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"])) {
      return new ValidationError("File type is invalid", "fileUpload");
    }

    if (isInvalidFileSize(value)) {
      return new ValidationError("File size is invalid", "fileUpload");
    }

    if (isInvalidFileName((value as File).name)) {
      return new ValidationError("File name is invalid", "fileUpload");
    }

    return undefined;
  }

  private static readonly validationStrategies: Record<
    UploadPurchaseOrdersFormDataKey,
    (inputValue: unknown) => ValidationError<UploadPurchaseOrdersFormDataKey> | undefined
  > = {
    fileUpload: UploadPurchaseOrdersFormValidator.validateFileUpload
  };

  static validatePurchaseOrderFormData<T extends UploadPurchaseOrdersFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(
      formData,
      UploadPurchaseOrdersFormValidator.validationStrategies
    ) as ValidationErrors<T>;
  }
}

export { UploadPurchaseOrdersFormValidator };
